import { Routes } from '@angular/router';
import { HomePage } from './home/pages/home/home.page';
import { SUBSCRIPTION_ROUTES } from './subscription/subscription.routes';
import { ModifyAmountModalComponent } from './pages/account-detail/modify-amount/modify-amount.component';
import { OptionModifyModalComponent } from './pages/account-detail/option-modify-modal/option-modify-modal.component';
import { StopSubscrModalComponent } from './pages/account-detail/stop-subscr-modal/stop-subscr-modal.component';
import { ModifyRegimenComponent } from './pages/account-detail/modify-regimen/modify-regimen.component';

import { environment } from 'src/environments/environment';
import { AccountDetailComponent } from './pages/account-detail/account-detail.component';
import { SuccessfulMoficationComponent } from './pages/successful-modification/successful-modifcation.component';
import { SuccessfulStopSubscriptionComponent } from './pages/successful-stop-subscription/successful-stop-subscription.component';
import { SuccessfulRegimenModificationComponent } from './pages/successful-regimen-modification/successful-regimen-modification.component';
import { loadRemoteModule } from '@angular-architects/module-federation';

export const APV_ROUTES: Routes = [
  {
    path: 'home',
    component: HomePage,
  },
  ...SUBSCRIPTION_ROUTES,
  {
    path: 'detail',
    component: AccountDetailComponent,
  },
  {
    path: 'successful-modifcation',
    component: SuccessfulMoficationComponent,
  },
  {
    path: 'successful-stop',
    component: SuccessfulStopSubscriptionComponent,
  },
  {
    path: 'successful-regimen-modification',
    component: SuccessfulRegimenModificationComponent,
  },
  {
    path: 'security',
    loadChildren: () =>
      loadRemoteModule({
        type: 'module',
        remoteEntry: environment.SECURITY_MODULE.BASE_URL,
        exposedModule: './VALIDACIONES',
      }).then((m) => m.ValidacionesModule),
  },
  {
    path: 'option-modify',
    component: OptionModifyModalComponent,
  },
  {
    path: 'modify',
    component: ModifyAmountModalComponent,
  },
  {
    path: 'stop',
    component: StopSubscrModalComponent,
  },
  {
    path: 'regime-modify',
    component: ModifyRegimenComponent,
  },
];
